import { defineMessages } from 'react-intl';

export default defineMessages({
  FORBIDDEN_TITLE: {
    defaultMessage: 'Accès refusé (Erreur 403)',
  },

  FORBIDDEN_DESCRIPTION: {
    defaultMessage: "Vous n'avez pas l'autorisation d'accéder à cette page.",
  },

  RETURN_TO_HOME: {
    defaultMessage: "Retour à l'accueil",
  },
});
